import { render, staticRenderFns } from "./qxButton.vue?vue&type=template&id=59619bd4&"
import script from "./qxButton.vue?vue&type=script&lang=js&"
export * from "./qxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports